import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { EventsService } from "../../_services/events.service";
import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ExcelServicesService } from "../../_services/excel-services.service";

declare var $: any;

@Component({
  selector: 'app-eventbookings',
  templateUrl: './eventbookings.component.html',
  styleUrls: ['./eventbookings.component.css']
})
export class EventbookingsComponent implements OnInit {

  eventsList: [];
  userdetaild: string;
  returnUrl: string;
  baseUrl: string = environment.baseUrl;
  id = this.route.snapshot.params.id;

  constructor(private authenicationService: AuthenicationService, private excelService:ExcelServicesService, private router: Router, private spinnerService: Ng4LoadingSpinnerService, private route: ActivatedRoute,private toaster: ToasterService, private eventsservice: EventsService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    const payload = {
      id: this.id
    };

    this.getEventBooking(payload);
  }

  exportAsXLSX():void {
    const final_data = [];
    this.eventsList.map((eventdata, index)=>{
      const event_data={};
       event_data["Title"] = eventdata["eventObj"]['event_title'];
       event_data["Date"] = eventdata["eventObj"]['event_date'];
       event_data["Start Time"] = eventdata["eventObj"]['event_start']; 
       event_data["End Time"] = eventdata["eventObj"]['event_end'];
       event_data["Organisation"] = eventdata["orgObj"]['name'];
       event_data["User Name"] = eventdata["userObj"]["users_name"];
       event_data["Email"] = eventdata['userObj']['users_email'];
       event_data["Phone"] = eventdata['userObj']['users_mobile'];
       event_data["Status"] = eventdata['booking_status'];
       event_data["Subscription"] = eventdata['activeSubscription'];
       final_data.push(event_data);
    })
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(final_data, 'events');
    this.spinnerService.hide();
  }

  getEventBooking(id) {
    this.eventsservice.getEventBookingByEventId(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.eventsList = data.bookingDetails;
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('eventsList', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
        },
        error => {
          this.toaster.showError('eventsList', error.error.ResponseMessage);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

}
